import { Info } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectTrigger,
  SelectValue,
} from "common/components/ui/Select";
import SelectButton from "common/components/ui/SelectButton";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { typedObjectEntries } from "common/helpers/utils";
import type { KeywordTypes } from "common/types";

import { KEYWORD_OPTIONS } from "../../../../constants";

interface KeywordTypeSelectProps {
  selectedKeywordType: KeywordTypes;
  setSelectedKeywordType: (keyword: KeywordTypes) => void;
  isDisabled: boolean;
  size: "sm" | "lg";
}

export default function KeywordTypeSelect({
  selectedKeywordType,
  setSelectedKeywordType,
  isDisabled,
  size,
}: KeywordTypeSelectProps) {
  const { t } = useTranslation("campaigns", {
    keyPrefix: "targetingSetup",
  });

  return (
    <div className="flex items-center gap-x-1">
      <Select
        value={selectedKeywordType}
        onValueChange={setSelectedKeywordType}
        disabled={isDisabled}
      >
        <SelectTrigger className="min-w-[120px] lg:w-40" asChild>
          <SelectButton hasSelection={!!selectedKeywordType} size={size}>
            <SelectValue />
          </SelectButton>
        </SelectTrigger>
        <SelectContent>
          {typedObjectEntries(KEYWORD_OPTIONS).map(([key, { label }]) => (
            <SelectItem value={key} key={key}>
              <SelectItemText>{label}</SelectItemText>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Tooltip>
        <TooltipTrigger>
          <Info size={16} weight="fill" className="fill-black-300" />
        </TooltipTrigger>
        <TooltipContent side="bottom">{t("keywordsTooltip")}</TooltipContent>
      </Tooltip>
    </div>
  );
}
